import * as React from 'react';

interface UpdateBeneficiaryProps {
    beneficiary: any;
    emitHandleViewOrUpdate: any;
    emitHandleRemove: any;
}

export class UpdateBeneficiariesItem extends React.Component<UpdateBeneficiaryProps, any> {

    constructor(props) {
        super(props);
        this.state = {
            updateReminderDismissed: false,
            selectedBenefit: {},
            isInEdit: false,
        }

        this.changeEdit = this.changeEdit.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleViewOrUpdate = this.handleViewOrUpdate.bind(this);
    }
    
    handleViewOrUpdate() {
        this.props.emitHandleViewOrUpdate(this.props.beneficiary.id);
    }
    
    handleRemove() {
        this.props.emitHandleRemove(this.props.beneficiary.id);
    }

    changeEdit() {
        this.setState({ isInEdit: !this.state.isInEdit });
    }

    public render() {
        const beneficiary = this.props.beneficiary;
        return (
            <div className="px-4 py-3 row align-items-center">
                <div className="col-3 col-md-4">
                   <h4 className="update-beneficiaries__name">{ beneficiary.name }</h4>
                </div>
                <div className="col-9 col-md-8">
                    <div className="row justify-content-end justify-content-xl-end align-items-center">
                        <div className="col-4 col-md-6 col-lg-6 col-xl-3">
                            <h4 className="mb-0 update-beneficiaries__percentage font-weight-bold">{ beneficiary.percentage }%</h4>
                        </div>
                        <div className="col-6 col-md-6 col-lg-6 col-xl-5 update-beneficiaries__view-or-update">
                            <button onClick={this.handleViewOrUpdate} className="btn w-100">View or update</button>
                        </div>
                        <div className="col-6 col-lg-6 col-xl-4">
                            <button onClick={this.handleRemove} className="btn update-beneficiaries__remove btn-outline-red w-100">Remove</button>
                        </div>
                    </div>
                </div>
            </div> 
        )
    }
}